<div>
  <div>
    <label class="b-toggle">
      <input type="checkbox" [formControl]="toggleControl" #toggle>
      <span class="b-toggle__slider"></span>
    </label>
  </div>
</div>
